import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {catchError, Observable, tap, throwError} from 'rxjs';
import {LoadWicketUser, SetWicketUser} from './user.actions';
import {WicketUserDataService} from '@tisa-group/core/api/wicket/user-data/user-data.service';
import {WicketUser} from '@tisa-group/models';

export type UserStateModel = {
  user: WicketUser | null | undefined;
};

@State<UserStateModel>({
  name: 'user',
  defaults: {
    user: undefined,
  },
})
@Injectable()
export class UserState {
  @Action(LoadWicketUser)
  fetchUser(
    ctx: StateContext<UserStateModel>,
    action: LoadWicketUser,
  ): Observable<WicketUser> {
    // Set undefined to show spinner until we get user data
    ctx.dispatch(new SetWicketUser(undefined));

    return this.userService.getUserData().pipe(
      tap(user => {
        ctx.setState({user});
      }),
      catchError((error: HttpErrorResponse) => {
        // The auth interceptor handles 403 errors
        if (error?.status !== 403) {
          // Set null to hide spinner if failed
          ctx.setState({user: null});
        }

        return throwError(() => error);
      }),
    );
  }

  @Action(SetWicketUser)
  setUser(ctx: StateContext<UserStateModel>, {user}: SetWicketUser): void {
    ctx.setState({user});
  }

  @Selector()
  static user(state: UserStateModel): WicketUser | undefined | null {
    return state.user;
  }

  @Selector()
  static isLoadingUserData(state: UserStateModel): boolean {
    return state.user === undefined;
  }

  constructor(readonly userService: WicketUserDataService) {}
}
